export default "__VITE_ASSET__BU5bOOJZ__"